import 'css-chunk:src/index/components/floor_button/floor_button.module.scss';export default {
  "content": "content__-eMnX",
  "active": "active__33JjD",
  "floor": "floor__Slv7W",
  "arrow": "arrow__nx3Ys",
  "icons": "icons__N4qRq"
};